module.exports = __webpack_public_path__ + "img/guide12.989f96e1.jpg";